const FinmoPayoutStatus = {
  pending: 'PENDING',
  completed: 'COMPLETED',
  failed: 'FAILED',
};

export default FinmoPayoutStatus;
